import { render, staticRenderFns } from "./standings.vue?vue&type=template&id=6796a5b2&scoped=true&"
import script from "./standings.vue?vue&type=script&lang=js&"
export * from "./standings.vue?vue&type=script&lang=js&"
import style0 from "./standings.vue?vue&type=style&index=0&id=6796a5b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6796a5b2",
  null
  
)

export default component.exports